import { render, staticRenderFns } from "./printersForm.vue?vue&type=template&id=ca07593a"
import script from "./printersForm.vue?vue&type=script&lang=js"
export * from "./printersForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports